import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { countries } from 'apps/payment/countries';

import Spinner from 'components/Spinner';
import Heading from 'components/Heading';
import Button from 'components/Button';
import Radio from 'components/Form/Radio/Radio';

import {
  AddressCardWrapper,
  ActionsRowWrapper,
  RadioWrapper,
  InnerModal,
  InnerModalContent,
  InnerModalActions,
  PhoneAnchor,
} from 'apps/addresses/blocks/AddressCard.styles';

const AddressCard = props => {
  const {
    t,
    address,
    singleCard,
    size = 'small',
    MakeDefault,
    ShipTo,
    StartDelete,
    Delete,
    CancelDelete,
  } = props;
  const { id, company, address2, province, city, phone } = address;

  // Remove all spaces
  const parsePhone = nr => nr.replace(new RegExp(' ', 'g'), () => '');

  return (
    <AddressCardWrapper
      selected={props.selected}
      noMargin={singleCard}
      size={size}
    >
      {!singleCard && address?.loading && (
        <InnerModal>
          <Spinner isDark />
        </InnerModal>
      )}

      {!singleCard && ShipTo && (
        <ActionsRowWrapper>
          <Button
            size='small'
            appearance='plain'
            margin='0 0 0.5rem 0'
            text={t('Ship To This Address')}
            onClick={() => ShipTo(address)}
          />
        </ActionsRowWrapper>
      )}

      <Heading singleLine level='6' size={size} weight='regular'>
        {address?.name}
        {company && `, ${company}`}
      </Heading>
      <Heading singleLine level='6' size={size} weight='regular'>
        {address?.address1}
      </Heading>
      {address2 && (
        <Heading singleLine level='6' size={size} weight='regular'>
          {address?.address2}
        </Heading>
      )}
      <Heading singleLine level='6' size={size} weight='regular'>
        {address?.zip}
        {province && ` | ${province}`}
        {city && ` | ${city}`}
      </Heading>
      <Heading singleLine level='6' size={size} weight='regular'>
        {countries?.[address?.country]}
      </Heading>
      {phone && typeof phone === 'string' && (
        <PhoneAnchor href={`tel:${parsePhone(phone)}`}>
          <Heading singleLine level='6' size={size} weight='regular'>
            {`${t('Phone')}:`}
            &nbsp;
            <Button size='small' appearance='plain' text={phone} />
          </Heading>
        </PhoneAnchor>
      )}

      {!singleCard && MakeDefault && (
        <RadioWrapper onClick={() => MakeDefault(address)}>
          <Radio
            id={id}
            value={id}
            groupName={id}
            size='xsmall'
            label={t('Make Default')}
            checked={address?.default}
          />
        </RadioWrapper>
      )}

      {!singleCard && StartDelete && Delete && CancelDelete && (
        <>
          {props.deleting === id && (
            <InnerModal large>
              <InnerModalContent>
                <Heading singleLine level='4' size='medium'>
                  {t('Remove this address?')}
                </Heading>
                <InnerModalActions>
                  <Button
                    outline
                    size='small'
                    appearance='plain'
                    variant='destructive'
                    text={t('Remove')}
                    onClick={() => Delete(address)}
                  />
                  <Button
                    outline
                    size='small'
                    appearance='plain'
                    variant='minimal'
                    text={t('Cancel')}
                    onClick={() => CancelDelete(address)}
                  />
                </InnerModalActions>
              </InnerModalContent>
            </InnerModal>
          )}
          <ActionsRowWrapper>
            <Button
              size='small'
              appearance='plain'
              text={t('Remove')}
              onClick={() => StartDelete(address)}
            />
          </ActionsRowWrapper>
        </>
      )}
    </AddressCardWrapper>
  );
};

AddressCard.defaultProps = {
  singleCard: false,
};

AddressCard.propTypes = {
  t: PropTypes.func,
  address: PropTypes.object,
  size: PropTypes.string,
  selected: PropTypes.bool,
  MakeDefault: PropTypes.func,
  ShipTo: PropTypes.func,
  deleting: PropTypes.string,
  StartDelete: PropTypes.func,
  Delete: PropTypes.func,
  CancelDelete: PropTypes.func,
  singleCard: PropTypes.bool,
};

export default withNamespaces()(observer(AddressCard));
